<div class="financial-health-feature-card mfp-white-box">
  <div class="card__content">
    <div class="card__header">
      <img
        *ngIf="insurance"
        mfpLazyImage
        lazySrc="assets/icons/protection-card-{{ insurance }}.svg"
        [ngClass]="insurance !== 'DEATH' ? 'card__icon' : 'card__icon-large'"
      />
      <h2 class="card__title" [ngClass]="{'card__title--small': showIndicator}">{{ title }}</h2>
      <ng-container *ngIf="showIndicator">
        <mfp-circular-indicator [basePercentage]="base" [currentPercentage]="current"></mfp-circular-indicator>
      </ng-container>
    </div>
    <div class="card__body">
      <div class="card__value">
        <h2 class="card__value-number">{{ value }}</h2>
        <p class="card__value-max">{{ ' / ' + max }}</p>
      </div>
      <p class="card__subtext" *ngIf="newProducts">
        {{ newProducts + ' ' + ('FINANCIAL_HEALTH.PLANS_TAB.PROTECTIONS.ADDED' | translate) }}
      </p>
    </div>
  </div>
</div>
